// extracted by mini-css-extract-plugin
module.exports = {"grouping":"skillsGroup-module--grouping--teUa9","grid":"skillsGroup-module--grid--3_oOP"};